<template>
    <b-card @click="$emit('task-clicked')"
            v-bind:class="{ active: active, selected: selected, deleted: productTask.productOrder.deleted}">
        <div class="badges mb-2">
            <b-badge v-if="productTask.order.priority !== 0" variant="danger" class="badge mr-1"><icon name="exclamation"></icon> Срочно</b-badge>
            <b-badge v-if="productTask.order.typeDelivery.keyword === TYPE_DELIVERY.PICKUP" variant="warning" class="badge"><icon name="truck-pickup"></icon> Самовывоз</b-badge>
            <b-badge v-if="productTask.order.forTime !== null" class="badge"><icon class="mr-2" name="clock"></icon>На время: {{productTask.order.forTime}}</b-badge>
        </div>
        <h4>Заказ #{{productTask.order.idDay}}</h4>
        <h5 v-if="active">
            <template v-if="userRole === roles.USER_ROLE_PIZZA_DOUGH">{{getPizzaSize(productTask)}}{{getNumberOfDough(productTask)}}</template>
            <template v-else>{{`${productTask.order.brandName} - ${productTask.productOrder.name}`}}{{getNumberOfPizza(productTask)}}</template>
        </h5>
        <h6>{{productTask.time}}</h6>
        <b-list-group v-if="userRole === roles.USER_ROLE_PIZZA_COOKER && active"  v-for="prD in JSON.parse(productTask.productOrder.product.composition)"
                      :key="prD"
                      class="d-inline-flex">
            <b-card no-body><p class="descriptProduct">{{prD}}</p></b-card>
        </b-list-group>
        <!--userRole === roles.USER_ROLE_PIZZA_COOKER-->
        <div>
            <span v-if="productTask.order.kitchenComment" class="comment">{{productTask.order.kitchenComment}}</span>
        </div>
        <div class="mb-1">
            <b-spinner label="Spinning" v-if="spinning" variant="success"></b-spinner>
        </div>
    </b-card>
</template>

<script>
import {TYPE_DELIVERY} from '../constants/keywords'
import {USER_ROLE_PIZZA_COOKER, USER_ROLE_PIZZA_DOUGH} from '../constants/roles'
export default {
  name: 'TaskProductItem',
  props: {
    productTask: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    userRole: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    spinning: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      TYPE_DELIVERY,
      roles: {USER_ROLE_PIZZA_COOKER, USER_ROLE_PIZZA_DOUGH}
    }
  },
  methods: {
    getPizzaSize (taskWorkShop) {
      return taskWorkShop.productOrder.smallSize ? 'Тонкое тесто' : 'Традиционное тесто'
    },
    getNumberOfDough (taskWorkShop) {
      return (parseInt(taskWorkShop.productOrder.count) !== 1 || parseInt(taskWorkShop.productOrder.product.numberOfPizza) !== 1)
        ? ' X ' + taskWorkShop.productOrder.count * taskWorkShop.productOrder.product.numberOfPizza : ''
    },
    getNumberOfPizza (taskWorkShop) {
      return parseInt(taskWorkShop.productOrder.count) !== 1
        ? ' X ' + taskWorkShop.productOrder.count : ''
    }
  }
}
</script>

<style scoped>
    .deleted {
        background: #F5C6CB;
    }
    .active {
        background-color: #efb74a;
        border: 1px #333333 solid;
    }
    .active.deleted {
        background: #F3A1A9;
    }
    .selected, .selected.deleted {
        background: #00DE00;
    }
    .descriptProduct {
        margin: 0;
        padding: 5px;
    }
    .comment {
        margin-top:5px;
        background:#c3e3ff;
        padding:2px 10px;
        border:1px dashed #000;
        display:inline-block;
    }
</style>



// WEBPACK FOOTER //
// src/components/TaskProductItem.vue